import ProductTitle from './ProductTitle';
export default ProductTitle;
